module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-screen-00cd23e73fe76b5467e97dfb695c08f7.png";